import { ACTIVATE_LIVE_INDIC_ANIMATION ,  DEACTIVATE_LIVE_INDIC_ANIMATION} from "./liveIndicReducer"

export const activateLiveIndicAnimation = () => ({
    type: ACTIVATE_LIVE_INDIC_ANIMATION,
})

export const deactivateLiveIndicAnimation = () => ({
    type: DEACTIVATE_LIVE_INDIC_ANIMATION,
})